import { gql } from '@apollo/client'

export interface UpdateUserLastLoginSessionRequestInput {
  userId: string
}

export interface SaveUserLastLoginSessionResponse {
  saveUserLastLoginSession: {
    isSuccess: boolean
    error: string | null
  }
}

export const SAVE_USER_LAST_LOGIN_SESSION_MUTATION = gql`
  mutation saveUserLastLoginSession($input: UpdateUserLastLoginSessionRequestInput) {
    saveUserLastLoginSession(request: $input) {
      isSuccess
      error
      __typename
    }
  }
`
